import gql from 'graphql-tag';
import { actionGQLFields } from '../common/action.fields.js';
import { appCollaboratorGQLFields, } from './appCollaborator.fields.js';
export const globalAppCollaboratorsQuery = (fields) => gql `
  query globalAppCollaborators($appId: String!) {
    globalAppCollaborators(appId: $appId) {
      ${appCollaboratorGQLFields(fields)}
    }
  }
`;
export const globalAddAppCollaboratorGQLMutation = (fields) => gql `
  mutation globalAddAppCollaborator($appId: String!, $input: AddAppCollaboratorInput!) {
    globalAddAppCollaborator(appId: $appId, input: $input) {
      ${appCollaboratorGQLFields(fields)}
    }
  }
`;
export const globalRemoveAppCollaboratorGQLMutation = (fields) => gql `
  mutation globalRemoveAppCollaborator($appId: String!, $collaboratorId: String!) {
    globalRemoveAppCollaborator(appId: $appId, collaboratorId: $collaboratorId) {
      ${actionGQLFields(fields)}
    }
  }
`;
